import React, {Component} from 'react';
import './style.scss';

class DropzonePreview extends Component {

    constructor(props, context) {
		super(props, context);

        this.state = {}
    }


    render = () => {
        return (
            <div className="drop-inner">
                <img src={this.props.image} />
                <p>{this.props.name}</p>
            </div>
        )
        

    }
}

export default DropzonePreview;


// WEBPACK FOOTER //
// ./src/Components/DropzonePreview/index.js